import React from 'react';
import * as S from './StatusIcon.styles';

import IconSelector from '@ibibo/icon-selector';

export const StatusIconUpcoming = () => {
  return(
    <S.StatusIconPaddingWrap>
      <IconSelector iconKey='hotelupcoming' />
    </S.StatusIconPaddingWrap>
  );
}


export const StatusIconCancelled = () => {
  return(
    <S.StatusIconPaddingWrap>
      <IconSelector iconKey='hotelcancelled' />
    </S.StatusIconPaddingWrap>
  );
}

export const StatusIconCompleted = () => {
  return(
    <S.StatusIconPaddingWrap>
      <IconSelector iconKey='hotelcompleted' />
    </S.StatusIconPaddingWrap>
  );
}

export const StatusIconFailed = () => {
  return(
    <S.StatusIconPaddingWrap>
      <IconSelector iconKey='hotelfailed' />
    </S.StatusIconPaddingWrap>
  );
}

export const StatusIconInProgress = () => {
  return(
    <S.StatusIconWrap>
      <IconSelector iconKey='bookingprogress' />
    </S.StatusIconWrap>
  );
}

